<div class="case-request-wrapper">
  <h1 class="bo-title-text d-none" [innerHtml]="referenceDataLabels.CaseSummaryCaseActivity | localizeLabel"></h1>
  <ng-container *ngIf="caseRequests">
    <div
      *ngIf="caseRequests.length > 0"
      class="bo-activity-subtitle vo-heading-regular-18 mb-15"
      [innerHtml]="referenceDataLabels.CaseActivity | localizeLabel"
    ></div>
    <boi-accordion>
      <div
        class="mb-30"
        [ngClass]="{ 'mr-35': applicationHostTypeService.isBrokerInterfaceType() }"
        *ngFor="let caseRequest of caseRequests; let i = index; trackBy: trackCaseRequestStatus"
      >
        <div class="d-flex">
          <div class="flex-1">
            <div
              *ngIf="isCaseRequestTypeESIS(caseRequest)"
              class="vo-body-regular-16 bo-illustration-subtitle"
              [innerHtml]="
                (referenceDataLabels.IllustrationRequestedLabel | localizeLabel) +
                ' ' +
                caseRequest.RequestTypeIteration
              "
            ></div>
            <boi-case-request-status-history
              class="activity-container"
              [caseRequest]="caseRequest"
              [showOnlyMostRecentHistoryStatus]="showOnlyMostRecentHistoryStatus"
            >
            </boi-case-request-status-history>

            <div class="artefact bo-label-text vo-body-regular-14">
              <span
                class="vo-body-bold-14"
                [innerHtml]="
                  (caseRequest.RequestTypeCode === referenceDataOptionLists.SwitchRequestTypeEsis
                    ? referenceDataLabels.RequestIllustration
                    : referenceDataLabels.RequestSwitch
                  ) | localizeLabel
                "
              ></span>
              <span
                class="bo-info-text"
                [innerHtml]="' ' + (caseRequest.CreatedDate | date : 'dd/MM/yyyy HH:mm:ss') + ' '"
              ></span>

              <span class="bo-info-text" [innerHtml]="' ' + (referenceDataLabels.By | localizeLabel) + ' '"></span>

              <a
                class="link"
                *ngIf="caseRequest.AgentIDAsHash"
                (click)="goToAgentDetails.emit(caseRequest.AgentIDAsHash)"
                >{{ caseRequest.AgentFullName }} ({{ caseRequest.AgentCompany }})</a
              >
              <a class="link" *ngIf="caseRequest.DirectCustomerIDAsHash" (click)="goToCustomersTab.emit()">{{
                caseRequest.DirectCustomerFullName
              }}</a>

              <div>
                <span class="bo-info-text"
                  >{{ caseRequest.ProductDescription }} ({{ caseRequest.ProductCode }}) |
                </span>
                <span class="bo-info-text"
                  >{{ caseRequest.AccountLTV }}% {{ referenceDataLabels.LTV | localizeLabel }} |
                </span>
                <span class="bo-info-text">{{ caseRequest.SwitchedSubaccountsInfo }} | </span>
                <span
                  boiCategorizeCaseStatus
                  [caseStatus]="caseRequest.InitialStatusCode"
                  [innerHtml]="
                    caseRequest.InitialStatusCode | localizeOption : referenceDataOptionLists.SwitchCaseStatus
                  "
                ></span>
              </div>
            </div>
          </div>
          <div
            *ngIf="applicationHostTypeService.isBrokerInterfaceType()"
            class="expand-button cursor-pointer vo-icon-plus vo-icon align-self-start vo-icon--16"
            [ngClass]="{ 'expand-button--expanded': expandedStateOfIllustrations[i] }"
            (click)="toggleCaseDetails(i)"
          ></div>
        </div>
        <boi-overview-illustration-status
          *ngIf="
            expandedStateOfIllustrations[i] &&
            isCaseRequestTypeESIS(caseRequest) &&
            applicationHostTypeService.isBrokerInterfaceType()
          "
          [caseIdAsHash]="applicationCase.CaseNumberAsHash"
          [interfaceTypeCode]="interfaceTypeCode"
          [caseRequest]="caseRequest"
          [areIllustrationsReady]="areIllustrationsReady"
          (productTransfer)="onProductTransfer($event)"
        ></boi-overview-illustration-status>
        <boi-overview-switch-offer-status
          *ngIf="
            expandedStateOfIllustrations[i] &&
            !isCaseRequestTypeESIS(caseRequest) &&
            isBoiInterface &&
            applicationHostTypeService.isBrokerInterfaceType()
          "
          [caseIdAsHash]="applicationCase.CaseNumberAsHash"
          [interfaceTypeCode]="interfaceTypeCode"
          [caseRequest]="caseRequest"
        ></boi-overview-switch-offer-status>
      </div>
    </boi-accordion>
  </ng-container>
</div>
